// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer */
footer {
  background: var(--gray-900);
  color: var(--gray-300);
  padding: var(--space-2xl) var(--space-lg) var(--space-lg);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--space-xl);
  margin-bottom: var(--space-xl);
}

.footer-section h4 {
  color: var(--white);
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: var(--space-md);
}

.footer-section p {
  color: var(--gray-300);
  line-height: 1.6;
  margin-bottom: var(--space-md);
}

.footer-contact p {
  margin: var(--space-xs) 0;
  font-size: 0.9rem;
}

.footer-contact strong {
  color: var(--white);
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin: var(--space-xs) 0;
}

.footer-links a {
  color: var(--gray-300);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: var(--light-teal);
}

.footer-bottom {
  border-top: 1px solid var(--gray-700);
  padding-top: var(--space-lg);
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-md);
}

.footer-legal {
  display: flex;
  gap: var(--space-lg);
}

.footer-legal a {
  color: var(--gray-300);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.footer-legal a:hover {
  color: var(--light-teal);
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: var(--space-lg);
  }
  
  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
  }
  
  .footer-legal {
    justify-content: center;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* Footer */\nfooter {\n  background: var(--gray-900);\n  color: var(--gray-300);\n  padding: var(--space-2xl) var(--space-lg) var(--space-lg);\n}\n\n.footer-content {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.footer-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: var(--space-xl);\n  margin-bottom: var(--space-xl);\n}\n\n.footer-section h4 {\n  color: var(--white);\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: var(--space-md);\n}\n\n.footer-section p {\n  color: var(--gray-300);\n  line-height: 1.6;\n  margin-bottom: var(--space-md);\n}\n\n.footer-contact p {\n  margin: var(--space-xs) 0;\n  font-size: 0.9rem;\n}\n\n.footer-contact strong {\n  color: var(--white);\n}\n\n.footer-links {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-links li {\n  margin: var(--space-xs) 0;\n}\n\n.footer-links a {\n  color: var(--gray-300);\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: color 0.3s ease;\n}\n\n.footer-links a:hover {\n  color: var(--light-teal);\n}\n\n.footer-bottom {\n  border-top: 1px solid var(--gray-700);\n  padding-top: var(--space-lg);\n}\n\n.footer-bottom-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-md);\n}\n\n.footer-legal {\n  display: flex;\n  gap: var(--space-lg);\n}\n\n.footer-legal a {\n  color: var(--gray-300);\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: color 0.3s ease;\n}\n\n.footer-legal a:hover {\n  color: var(--light-teal);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .footer-grid {\n    grid-template-columns: 1fr;\n    gap: var(--space-lg);\n  }\n  \n  .footer-bottom-content {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .footer-legal {\n    justify-content: center;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
